var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-bottom-container",class:{small: _vm.small}},[_c('div',{staticClass:"card-bottom"},[_vm._t("left",[_c('div')]),_vm._t("middle",[_c('div')]),_vm._t("right",[_c('div')])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }